/** Подписи для `BonusTransaction.kind` (см. `backend/app/services/bonus_service.py`, channel audit). */
export const KIND_LABELS = {
  issue: "Выпуск QR (админ)",
  redeem: "QR начисление",
  debit_redeem: "QR списание",
  promo_profile: "акция ФИО",
  promo_birthday: "акция дата рождения",
  promo_phone: "акция телефон",
  promo_triple: "бонус за 4 шага",
  promo_yandex_review: "акция отзыв Яндекс",
  promo_2gis_review: "акция отзыв 2ГИС",
  referral_inviter: "реферальный бонус",
  birthday_loyalty: "подарок на день рождения",
  ch_forfeit: "удержание (канал)",
  ch_restore: "восстановление (канал)",
  raffle_win: "выигрыш в розыгрыше",
  admin_adj: "корректировка админа",
  qr_bonus: "бонус по QR",
};

export function bonusHistoryKindLabel(kind) {
  if (kind == null || kind === "") return "—";
  return KIND_LABELS[kind] ?? kind;
}
